import {GetUrlResponse} from "../interfaces/responses/GetUrlResponse";
import axios from "axios";

const REQUEST_TIMEOUT: number = 10000;

const axiosConsumer = axios.create({
    baseURL: '',
    withCredentials: true,
    timeout: REQUEST_TIMEOUT,
});

export const ApiConsumer = {
    async getUrl(url: string): Promise<GetUrlResponse> {
        const response = await axiosConsumer.get(url);
        return response.data;
    }
}